import { JcAuthService } from 'jcfirebase';
import { JCalAuth } from 'src/services/auth/models/JCalAuth';

export const jcalAuthService = new JcAuthService<JCalAuth>({
    toAuth: (user, claims) => new JCalAuth(user.uid, user.email, claims.admin === true),
});
